<div class="py-3 px-3 rounded" *ngIf="items.length" [ngClass]="classNames">
  <ul class="flex justify-center gap-4 list-none">
    <ng-container *ngFor="let item of items; let i = index">
      <mat-divider
        *ngIf="i !== 0"
        class="mx-4"
        [ngClass]="dividerClassNames"
        [vertical]="true"
      ></mat-divider>
      <li class="flex flex-col gap-y-2 items-center">
        <span class="">{{ item.title }}</span>
        <!-- The icon is painted as a mask rather than an <img> so it takes the
             surrounding text colour. The assets hard-code a white fill (they were
             drawn for the dark board), which made them invisible anywhere the
             board is light. Inheriting currentColor keeps the dark board looking
             exactly as before — its text is white, so the icon still is — while
             letting a light board tint the icon to suit.
             Same technique app-button-icon-ui already uses for its icons. -->
        <span
          *ngIf="item.icon"
          class="board-icon"
          [style.webkitMaskImage]="'url(assets/icons/' + item.icon + '.svg)'"
          [style.maskImage]="'url(assets/icons/' + item.icon + '.svg)'"
          [attr.aria-label]="item.icon"
        ></span>
        <span class="text-center font-semibold">{{ item.subtitle }}</span>
      </li>
    </ng-container>
  </ul>
</div>
